<template>
  <div v-if="answers" class="answer pa-2">
    <template v-if="isCommentToInbox">
      <p>{{ $t('Chatbot answers') }}</p>
      <template v-if="answers && answers[0].length > 0">
        <message-viewer :value="answers"></message-viewer>
      </template>
      <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
    </template>
    <template v-else>
      <p>{{ $t('Chatbot answers') }}</p>
      <template v-if="intent.a_type == 'json'">
        <div>
          <template v-if="!showMultipleChannel">
            <template v-if="answers && answers[0].length > 0">
              <message-viewer :value="answers"></message-viewer>
            </template>
            <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
          </template>
          <template v-else>
            <v-layout>
              <v-flex class="channel" shrink style="border-right: 1px solid #eee">
                <template v-for="social in conversationSocialChannelOptions">
                  <div
                    :key="`tab_${social.value}`"
                    :class="{ 'primary white--text': tab == social.value }"
                    class="py-1 pl-2 pr-2"
                    style="
                      border: 1px solid #eee;
                      border-width: 1px 0px 1px 1px;
                      border-top-left-radius: 5px;
                      border-bottom-left-radius: 5px;
                      cursor: pointer;
                    "
                    @click="$emit('handleChangeTab', social.value)"
                  >
                    <span :class="social.icon"></span>
                  </div>
                </template>
              </v-flex>
              <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                <template v-for="social in conversationSocialChannelOptions">
                  <template v-if="tab == social.value">
                    <template
                      v-if="
                        multiMessages[socialAnswers(social)] &&
                        multiMessages[socialAnswers(social)][0].length > 0
                      "
                    >
                      <message-viewer
                        :key="socialAnswers(social)"
                        :value="multiMessages[socialAnswers(social)]"
                      />
                    </template>
                    <p v-else :key="socialAnswers(social)" class="primary-color pl-1">
                      {{ $t('No reply') }}
                    </p>
                  </template>
                </template>
              </v-flex>
            </v-layout>
          </template>
        </div>
      </template>
      <template v-else-if="intent.a_type == 'text'">
        <div style="overflow-x: auto">
          <div>
            <div
              v-for="(answer, index) in answers"
              :key="'answer_' + index"
              style="margin-bottom: 5px; flex-grow: 1; padding: 0px 10px"
              :style="{ 'border-right': answers.length > 1 ? '1px dashed #eee' : '' }"
            >
              <div v-for="(message, mindex) in answer" :key="'message_' + mindex">
                <template v-if="message.type == 'text'">
                  <div
                    class="message"
                    style="
                      float: left;
                      position: relative;
                      border-radius: 12px;
                      max-width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                      margin-bottom: 5px;
                    "
                  >
                    <div style="font-size: 12px; color: black">
                      <div style="padding: 5px 8px 6px; background-color: #f1f0f0">
                        <span style="line-height: 15.36px">
                          <specialtext :text="message.value.text"></specialtext>
                        </span>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div
                      v-if="message.value.buttons.length > 0"
                      style="
                        float: left;
                        width: 100%;
                        border: 1px solid #eee;
                        border-bottom-left-radius: 12px;
                        border-bottom-right-radius: 12px;
                        overflow: hidden;
                      "
                    >
                      <ul class="list-group list-group-flush" style="margin-bottom: 0px">
                        <li
                          v-for="(button, bindex) in message.value.buttons"
                          :key="bindex"
                          class="list-group-item"
                          style="
                            border: none;
                            border-top: 1px solid #eee;
                            border-radius: 0px;
                            text-align: center;
                            padding: 2px 15px;
                          "
                          :style="{
                            'border-top': bindex != 0 ? '1px solid #eee' : 'none'
                          }"
                        >
                          <span style="color: #0084ff">{{ button.title }}</span>
                          <p style="margin: 0; font-size: 10px">
                            <template v-if="button.type == 'web_url'">
                              {{ button.url }}
                            </template>
                            <template v-if="button.type == 'postback'">
                              {{ button.payload }}
                            </template>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
                <template v-else-if="message.type == 'image'">
                  <div
                    class="message"
                    style="
                      float: left;
                      position: relative;
                      border-radius: 12px;
                      width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                      margin-bottom: 5px;
                    "
                  >
                    <div style="font-size: 12px; color: black">
                      <img :src="message.value" alt style="width: 100%" />
                    </div>
                  </div>
                </template>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="intent.a_type == 'template'">
        <generic-viewer :value="answers"></generic-viewer>
      </template>
      <template
        v-else-if="
          intent.a_type == 'message' ||
          intent.a_type == 'generic' ||
          intent.a_type == 'ntn_template'
        "
      >
        <intent-getstarted v-model="welcomemessage"></intent-getstarted>
      </template>
      <template v-else-if="intent.a_type == 'viewsummary'">
        <view-cart-summary-viewer></view-cart-summary-viewer>
      </template>
      <div v-else-if="intent.a_type == 'none'" class="pl-1">{{ $t('No reply') }}</div>
    </template>

    <template v-if="answers[0].length > 0">
      <div v-if="!isCommentToInbox && !hideChoice">
        <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
        <div class="quickreply">
          <template v-if="replies && replies.length > 0">
            <ul class="tags">
              <li v-for="(reply, index) in replies" :key="'reply_' + index" class="tag">
                {{ reply }}
              </li>
            </ul>
          </template>
          <template v-else>-</template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
export default {
  components: {
    IntentGetstarted,
    GenericViewer,
    MessageViewer
  },
  props: {
    intent: {
      default: null
    },
    answers: {
      default: null
    },
    tab: { default: null },
    multiMessages: { default: null, type: Object },
    fb_answers: { default: null },
    line_answers: { default: null },
    ig_answers: { default: null },
    ms_team_answers: { default: null },
    isCommentToInbox: {
      default: null
    },
    showMultipleChannel: {
      default: null
    },
    hideChoice: {
      default: null
    },
    replies: {
      default: null
    }
  },
  methods: {
    socialAnswers: (social) => {
      return `${social.value}_answers`
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Conversation/PreviewConversation.vue